import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=30762642&"
import script from "./StandardLayout.vue?vue&type=script&lang=ts&"
export * from "./StandardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports